import React from 'react';
import { useGetAdminAccountStatementQuery } from '../services/auth/authApi';
import { useNavigate } from 'react-router-dom';

const AdminAccountStatementPage = () => {
  const navigate = useNavigate();
  const { data: statementData, isLoading, error } = useGetAdminAccountStatementQuery();

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };
console.log('Account Statement Data:', statementData);
  return (
    <div className="w-full">
      {/* Header */}
      <div className="bg-[#1a3a3a] px-6 py-4 flex justify-between items-center mb-6">
        <h1 className="text-white text-2xl font-medium">Account Statement</h1>
        <button
          onClick={() => navigate(-1)}
          className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded font-medium"
        >
          Back
        </button>
      </div>

      {/* Content */}
      <div className="px-6">
        {isLoading ? (
          <div className="text-center py-16">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
            <p className="mt-4 text-gray-600">Loading...</p>
          </div>
        ) : error ? (
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
            <p className="text-red-600 text-lg">Error loading account statement</p>
          </div>
        ) : statementData?.transactions ? (
          <div>
            {/* Transactions Table */}
            <div className="bg-white rounded-lg shadow overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-400">
                  <thead>
                    <tr className="bg-gray-800 text-white">
                      <th className="border border-gray-400 px-2 py-2 text-left text-sm font-medium whitespace-nowrap">Date</th>
                      <th className="border border-gray-400 px-2 py-2 text-left text-sm font-medium whitespace-nowrap">Description</th>
                      <th className="border border-gray-400 px-2 py-2 text-right text-sm font-medium whitespace-nowrap">Prev. Bal</th>
                      <th className="border border-gray-400 px-2 py-2 text-right text-sm font-medium whitespace-nowrap">CR</th>
                      <th className="border border-gray-400 px-2 py-2 text-right text-sm font-medium whitespace-nowrap">DR</th>
                      <th className="border border-gray-400 px-2 py-2 text-right text-sm font-medium whitespace-nowrap">Comm+</th>
                      <th className="border border-gray-400 px-2 py-2 text-right text-sm font-medium whitespace-nowrap">Comm-</th>
                      <th className="border border-gray-400 px-2 py-2 text-right text-sm font-medium whitespace-nowrap">Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {statementData.transactions && statementData.transactions.length > 0 ? (
                      statementData.transactions.map((item, index) => (
                        <tr key={item.transactionId || index} className="hover:bg-gray-50">
                          <td className="border border-gray-400 px-2 py-2 text-sm whitespace-nowrap">
                            {formatDate(item.placeDate)}
                          </td>
                          <td className="border border-gray-400 px-2 py-2 text-sm whitespace-nowrap">
                            {item.details || '-'}
                          </td>
                          <td className="border border-gray-400 px-2 py-2 text-sm text-right font-medium whitespace-nowrap">
                            {item.previousBalance?.toFixed(2) || '0.00'}
                          </td>
                          <td className="border border-gray-400 px-2 py-2 text-sm text-right font-medium text-green-600 whitespace-nowrap">
                            {item.credit === 'Credit' ? item.transaction?.toFixed(2) : '-'}
                          </td>
                          <td className="border border-gray-400 px-2 py-2 text-sm text-right font-medium text-red-600 whitespace-nowrap">
                            {item.credit === 'Debit' ? item.transaction?.toFixed(2) : '-'}
                          </td>
                          <td className="border border-gray-400 px-2 py-2 text-sm text-right whitespace-nowrap">
                            -
                          </td>
                          <td className="border border-gray-400 px-2 py-2 text-sm text-right whitespace-nowrap">
                            -
                          </td>
                          <td className="border border-gray-400 px-2 py-2 text-sm text-right font-medium whitespace-nowrap">
                            {item.closingBalance?.toFixed(2) || '0.00'}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="border border-gray-400 px-4 py-8 text-center text-gray-500">
                          No transactions available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-16 text-gray-500 text-lg">
            No data available
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminAccountStatementPage;
